import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=77ab045a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=77ab045a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ab045a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ab045a')) {
      api.createRecord('77ab045a', component.options)
    } else {
      api.reload('77ab045a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=77ab045a&scoped=true", function () {
      api.rerender('77ab045a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/dataExports/layout/Index.vue"
export default component.exports